<template>
  <div class="text-center">
    <v-menu
      top
      offset-y
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          outlined
          small
          class="px-0"
        >
          <v-icon class="mx-0 px-0">
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-if="ticket.active_loan.loan_setup.loan_type === 'loan.type.creditLimit'"
        >
          <advances-modal />
        </v-list-item>
        <v-list-item>
          <original-loan-setup-modal
            :loan-id="loanId"
            :loan-type="loanType"
          />
        </v-list-item>
        <v-list-item>
          <payment-schedule-modal
            :loan-id="loanId"
            :loan-type="loanType"
          />
        </v-list-item>
        <v-list-item>
          <payments-made
            :loan-id="loanId"
          />
        </v-list-item>
      </v-list>
      <!--      We can add more menu option below-->
    </v-menu>
  </div>
</template>

<script>
import PaymentScheduleModal from './PaymentScheduleModal.vue';
import PaymentsMade from './PaymentsMade.vue';
import AdvancesModal from './AdvancesModal.vue';
import OriginalLoanSetupModal from './OriginalLoanSetupModal.vue';

export default {
  name: 'LoanActionMenu',
  components: {
    PaymentScheduleModal,
    PaymentsMade,
    AdvancesModal,
    OriginalLoanSetupModal,
  },
  props: {
    loanId: {
      type: Number,
      required: false,
      default: null,
    },
    loanType: {
      type: String,
      required: false,
      default: 'installment',
    },
    ticket: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      paymentSchedules: [],
      headers: [
        { title: 'Title', key: 'title' },
        { title: 'Principal Balance', key: 'principal_balance' },
        { title: 'charge amount', key: 'charge_amount' },
        { title: 'adb', key: 'adb' },
        { title: 'adb days', key: 'adb_days' },
        { title: 'Period', key: 'period' },
        { title: 'Period Start', key: 'period_start' },
        { title: 'Period End', key: 'period_end' },
        { title: 'Date', key: 'date' },
        { title: 'Last updated', key: 'lastUpdated' },
      ],
    };
  },
  created() {
    this.$axios
      .post('api/v1/support/ticket/loan/payment-schedule', {
        loanId: this.loanId,
        ticketId: this.$route.params.id,
      })
      .then((payScheduleRes) => {
        this.paymentSchedules = payScheduleRes.data;
      })
      .catch();
  },
};
</script>
